'use strict';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  productVersion: '',
  agentStates: [],
  allAgentStates: [],
  completionStatuses: [],
  elementStates: [],
  interactionStates: [],
  interactionTypes: [],
  pendingStatuses: [],
  softPhoneSettings: {
    enableWebRTCSoftphone: false,
    enabled: false,
    servers: [],
    autoAcceptInvites: true,
    forceUdp: true,
    debug: false,
    managedAudioMode: true
  }
};

export default {
  namespaced: true,

  /**
   * As a best practice: Actions call mutations which update our current state
   * Actions could execute sync or async operations.
   */
  actions,

  /**
   * Access to state values
   */
  getters,

  /**
   * Used to commit and track state changes
   * Mutations should always execute sync operations.
   */
  mutations,

  /**
   * Single source of truth
   */
  state
};
